import * as tslib_1 from "tslib";
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../_helpers';
import { WorkerEntity } from '../entity';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var WorkerService = /** @class */ (function (_super) {
    tslib_1.__extends(WorkerService, _super);
    function WorkerService(http) {
        var _this = _super.call(this, 'config/workers', WorkerEntity) || this;
        _this.http = http;
        return _this;
    }
    WorkerService.ngInjectableDef = i0.defineInjectable({ factory: function WorkerService_Factory() { return new WorkerService(i0.inject(i1.HttpClient)); }, token: WorkerService, providedIn: "root" });
    return WorkerService;
}(BaseService));
export { WorkerService };
